export const grantsData = [
  {
    id: 1,
    title: 'Climate Innovation Fund 2025',
    organization: 'Global Climate Foundation',
    description: 'Supporting innovative projects that address climate change through renewable energy, carbon reduction, and sustainable practices.',
    type: 'climate',
    amount: 500000,
    location: 'Global',
    deadline: 'June 30, 2025',
    targetAudience: ['nonprofits', 'researchers', 'social-enterprises', 'startups']
  },
  {
    id: 2,
    title: 'Education Excellence Grant',
    organization: 'International Education Alliance',
    description: 'Funding educational initiatives that improve access to quality education in underserved communities worldwide.',
    type: 'education',
    amount: 250000,
    location: 'Developing Countries',
    deadline: 'August 15, 2025',
    targetAudience: ['nonprofits', 'students', 'individuals']
  },
  {
    id: 3,
    title: 'Scientific Research Fellowship',
    organization: 'National Science Foundation',
    description: 'Supporting groundbreaking research in STEM fields with focus on sustainable development and innovation.',
    type: 'research',
    amount: 750000,
    location: 'United States',
    deadline: 'September 1, 2025',
    targetAudience: ['researchers', 'students']
  },
  {
    id: 4,
    title: 'Arts & Culture Initiative',
    organization: 'Creative Arts Council',
    description: 'Empowering artists and cultural organizations to create impactful works that inspire social change.',
    type: 'arts',
    amount: 100000,
    location: 'Europe',
    deadline: 'July 20, 2025',
    targetAudience: ['individuals', 'nonprofits']
  },
  {
    id: 5,
    title: 'Sustainable Business Accelerator',
    organization: 'Green Business Network',
    description: 'Accelerating sustainable businesses that create positive environmental and social impact.',
    type: 'business',
    amount: 300000,
    location: 'Global',
    deadline: 'October 10, 2025',
    targetAudience: ['startups', 'social-enterprises']
  },
  {
    id: 6,
    title: 'Community Development Fund',
    organization: 'UN Development Programme',
    description: 'Supporting community-led sustainable development projects in rural and urban areas.',
    type: 'sustainable-development',
    amount: 400000,
    location: 'Africa, Asia',
    deadline: 'November 30, 2025',
    targetAudience: ['nonprofits', 'social-enterprises']
  },
  {
    id: 7,
    title: 'Renewable Energy Research Grant',
    organization: 'Clean Energy Institute',
    description: 'Funding research and development of innovative renewable energy technologies.',
    type: 'climate',
    amount: 600000,
    location: 'Global',
    deadline: 'December 15, 2025',
    targetAudience: ['researchers', 'startups', 'social-enterprises']
  },
  {
    id: 8,
    title: 'Youth Education Scholarship',
    organization: 'Future Leaders Foundation',
    description: 'Scholarships for exceptional students pursuing higher education in developing countries.',
    type: 'education',
    amount: 50000,
    location: 'Latin America',
    deadline: 'May 31, 2025',
    targetAudience: ['students', 'individuals']
  },
  {
    id: 9,
    title: 'Digital Arts Innovation Grant',
    organization: 'Digital Culture Fund',
    description: 'Supporting digital artists creating innovative works using emerging technologies.',
    type: 'arts',
    amount: 150000,
    location: 'Global',
    deadline: 'August 30, 2025',
    targetAudience: ['individuals', 'startups']
  },
  {
    id: 10,
    title: 'Social Enterprise Seed Funding',
    organization: 'Impact Investors Network',
    description: 'Early-stage funding for social enterprises addressing poverty, inequality, and environmental challenges.',
    type: 'business',
    amount: 200000,
    location: 'Asia Pacific',
    deadline: 'September 20, 2025',
    targetAudience: ['startups', 'social-enterprises']
  },
  {
    id: 11,
    title: 'Ocean Conservation Research',
    organization: 'Marine Protection Alliance',
    description: 'Research grants for projects focused on ocean conservation and marine biodiversity.',
    type: 'research',
    amount: 450000,
    location: 'Coastal Regions',
    deadline: 'July 15, 2025',
    targetAudience: ['researchers', 'nonprofits']
  },
  {
    id: 12,
    title: 'Sustainable Agriculture Initiative',
    organization: 'Food Security Foundation',
    description: 'Supporting sustainable farming practices and food security projects in rural communities.',
    type: 'sustainable-development',
    amount: 350000,
    location: 'Sub-Saharan Africa',
    deadline: 'October 1, 2025',
    targetAudience: ['nonprofits', 'social-enterprises', 'individuals']
  }
]